import { loadTheme, ITheme } from 'office-ui-fabric-react';
import { FluentTheme } from '@fluentui/theme';

export const theme: ITheme = loadTheme(FluentTheme);
